import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import TrackingService from '@/core/tracking.service';
import userAgent from '@/services/userAgent.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTeaserTextWithOverlay',
  props: {
    descripheadlinetion: null,
    description: null,
    maxLines: null,
    buttonText: null,
    overlayHeadline: null,
    overlayPreheader: null,
    overlayContent: null,
    downloadUrl: null,
    downloadButtonText: null,
    toggle: { type: Boolean },
    hasOverlay: { type: Boolean, default: true },
    trackingName: null
  },
  setup(__props: any) {

const props = __props as { descripheadlinetion?: string, description?: string, maxLines?: number, buttonText?: string, overlayHeadline?: string, overlayPreheader?: string, overlayContent?: string, downloadUrl?: string, downloadButtonText?: string, toggle?: boolean, hasOverlay: boolean, trackingName?: string }



const isModalOpen = ref<boolean>(false);
const isPostProcessed = ref<boolean>(false);
const runAnimations = ref<boolean>(userAgent.isPrerender);

function initAnimations(): void {
    runAnimations.value = true;
}

function openModal() {
    isPostProcessed.value = false;
    isModalOpen.value = true;
    indentRichTextExceptImages();
    if (props.trackingName) { TrackingService.event('Mini page', props.trackingName, 'Open'); }
}

watch(() => props.toggle, onToggle);
function onToggle() {
    isModalOpen.value = !isModalOpen.value;
}

// disclaimer: im sorry but there is no way to style an element dependent on it not having children :(
function indentRichTextExceptImages() {
    setTimeout(() => {
        const overlayElement = document.getElementsByClassName('overlay-content')[0];
        if (overlayElement) {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < overlayElement.children.length; i++) {
                const pElement = overlayElement.children[i];
                const hasImage = hasImageChildren(pElement);
                if (!hasImage) {
                    pElement.classList.add('c-teaser-block-content-center');
                }
            }
        }
        isPostProcessed.value = true;
    }, 300);
}

function hasImageChildren(element: Element) {
    // tslint:disable-next-line:prefer-for-of
    for (let k = 0; k < element.children.length; k++) {
        const childElement = element.children[k];
        if (childElement.tagName === 'IMG') {
            return true;
        }
    }
    return false;
}

function descriptionStyles(maxLines: number) {
    if (!maxLines) {
        return;
    }

    const styles = {
        display: '-webkit-box',
        lineClamp: maxLines || 3,
        boxOrient: 'vertical',
        overflow: 'hidden'
    };

    return styles;
}


return { __sfc: true,props, isModalOpen, isPostProcessed, runAnimations, initAnimations, openModal, onToggle, indentRichTextExceptImages, hasImageChildren, descriptionStyles }
}

})